var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cycles"},[_c('cycles-top-panel',{on:{"create-cycle":_vm.openCreateModal}}),_c('cycles-table'),_c('cycles-modal',{attrs:{"show":_vm.showModal},on:{"update:show":function($event){_vm.showModal=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }